// The QR sign maker is written for Danish, Swedish and Norwegian only; other
// locales 404 (English comes later, seo/backlog.md #9).
export const QR_SIGN_PATH = "/qr-skilt" as const;
export const QR_SIGN_LOCALES = ["da", "sv", "no"] as const;

export type QrSignLocale = (typeof QR_SIGN_LOCALES)[number];

export function isQrSignLocale(locale: string): locale is QrSignLocale {
  return (QR_SIGN_LOCALES as readonly string[]).includes(locale);
}
